import { css } from "../../../../styled-system/css";

export const styles = {
  divCategoryHeader: () =>
    css({
      marginBottom: "baseUnit.mobile6",
      tablet: {
        borderBottom: "1px solid",
        borderBottomColor: "darkBlue",
      },
    }),
  h1CategoryHeadline: () =>
    css({
      textAlign: "center",
      desktop: {
        marginBottom: "baseUnit.mobile2",
      },
    }),
  imgCategoryIcon: () =>
    css({
      width: "64px",
      height: "64px",
      marginY: "baseUnit.mobile6",
      marginX: 0,
      "& svg": {
        width: "100%",
        height: "100%",
        "& path": {
          fill: "darkBlue",
        },
        "& polygon": {
          fill: "darkBlue",
        },
      },
      desktop: {
        width: "128px",
        height: "128px",
        marginBottom: "baseUnit.mobile2",
      },
    }),
  divTextCenteredColumn: () =>
    css({
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      desktop: {
        paddingY: "baseUnit.mobile3",
        paddingX: "baseUnit.mobile5",
      },
      "& div": {
        color: "headlineGrey",
      },
    }),
  imageCategoryHeader: () =>
    css({
      display: "none",
      tablet: {
        display: "block",
      },
      "& picture": {
        position: "relative",
        left: "50%",
        width: "100vw",
        marginLeft: "-50vw",
        maxWidth: "100%",
        tablet: {
          width: "100%",
          height: "auto",
          position: "initial",
          left: "initial",
          marginLeft: "initial",
          marginBottom: "baseUnit.mobile3",
          display: "block",
        },
      },
    }),
};
